import type { UseFormReturn } from "react-hook-form";
import { FormControl, FormField, FormItem, FormLabel, FormMessage, TextInput } from "@/components/ui";
import type { RepairIntakeFormData } from "@/store/useRepairIntakeStore";

type RepairIntakeSection8Props = {
  form: UseFormReturn<RepairIntakeFormData>;
};

export function RepairIntakeSection8({ form }: RepairIntakeSection8Props) {
  return (
    <>
      <FormField
        control={form.control}
        name="section8.yourName"
        render={({ field }) => (
          <FormItem>
            <FormLabel>1. Your Name</FormLabel>
            <FormControl>
              <TextInput {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="section8.customerName"
        render={({ field }) => (
          <FormItem>
            <FormLabel>2. Customer Name *</FormLabel>
            <FormControl>
              <TextInput {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
}
